<template>
  <div
    id="ace"
    class="bg-div"
  >
    <img
      class="bg-img"
      src="@/assets/images/company-specialty-bg.png"
    >
    <h1 class="h1">{{title}}</h1>
    <p class="p-des">{{des}}</p>
    <p class="p-content">{{content}}</p>
  </div>
</template>

<script>
export default {
  name: "CompanySpecialty",
  props: {
    title: {
      default: "",
    },
    des: {
      default: "",
    },
    content: {
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="stylus" scoped>
.bg-div {
  position: relative;
}

.bg-img {
  width: 100%;
}

.h1 {
  position: absolute;
  font-size: 2.9rem;
  color: #ffffff;
  left: 50%;
  transform: translateX(-50%);
  top: 2rem;
}

.p-des {
  position: absolute;
  color: #ffffff;
  top: 5rem;
  left: 50%;
  transform: translateX(-50%);
}

.p-content {
  position: absolute;
  color: #ffffff;
  max-width: 40rem;
  font-size: 1.3rem;
  top: 8rem;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/company/components/ContentSpecialty.vue